/**
*
* RedStream
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import Wrapper from 'components/Templates/dynamics/Wrapper';
import defaultTextValues from './defaultTextValues';


class RedStream extends React.PureComponent {

  render() {

    const {
      commonData,
      openEditor,
      commonProps,
      streams
    } = this.props;

    let isLiveOrPublic = false;

    if (commonData.componentPayload.streamId) {
      for (let i = 0; i < streams.length; i++) {
        if (streams[i].streamId === commonData.componentPayload.streamId && streams[i].isLive)  {
          isLiveOrPublic = true;
        }
      }
    }

    return (
      <Wrapper
        {...commonProps}
        
        typeOfStyle={'wrapper'}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
      >
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'wrapperWithMargin'}
          editorData={
            {
              editorType: 'wrapperWithMargin',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'descriptionWrapper'}
            defaultValues={defaultTextValues}
            editorData={
              {
                editorType: 'descriptionWrapper',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'sectionTitle'}
              defaultValues={defaultTextValues}
              type={'text'}
              editorData={
                {
                  editorType: 'sectionTitle',
                  ...commonData
                }
              }
            />
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'streamParagraph'}
              type={'text'}
              editorData={
                {
                  editorType: 'streamParagraph',
                  ...commonData
                }
              }
            />
          </Wrapper>
          {
            isLiveOrPublic ? (
              <>
                <Wrapper
                  {...commonProps}
                  typeOfStyle={'streamContainer'}
                  
                  stream={commonData.componentPayload.streamId}
                  type={'stream'}
                  streams={streams}
                  editorData={
                  {
                    editorType: 'streamContainer',
                    ...commonData
                  }
                }
                />
              </>
            ) : (
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'streamPlaceholder'}
                defaultValues={defaultTextValues} // add stream date if if stream is chosen?
                type={'text'}
                editorData={
                  {
                    editorType: 'streamPlaceholder',
                    ...commonData
                  }
                }
              />
            )
          }
        </Wrapper>
      </Wrapper>
    );
  }
}

RedStream.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
};

export default RedStream;
